import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Image from 'components/image';
import Link from 'components/link';
import LinkButton from 'components/link-button';
import GoToPageContent from 'components/go-to-page-content';
import imageResizer from 'js/image-resizer';
import useBreakpoints from 'hooks/use-breakpoints';

const FrontPageHero = ({
  heading,
  smallHeading,
  image,
  reportDownloadLink,
  lang,
}) => {
  const { isMobile } = useBreakpoints(true);
  const [imageHeight, setImageHeight] = useState(0);
  const [imageWidth, setImageWidth] = useState(0);

  useEffect(() => {
    if (typeof isMobile === 'undefined') {
      return;
    }

    if (isMobile) {
      setImageHeight(imageResizer.calcImageHeight(533, 100));
    } else {
      setImageHeight(imageResizer.calcImageHeight(window.screen.height, 100));
    }
  }, [isMobile]);

  useEffect(() => {
    setImageWidth(imageResizer.calcImageWidth(window.screen.width, 100));
  }, []);

  return (
    <div className="front-page-hero">
      <div className="front-page-hero__content">
        <div className="front-page-hero__container">
          <div className="front-page-hero__text-info">
            {smallHeading && (
              <span className="front-page-hero__small-heading">
                {smallHeading}
              </span>
            )}
            {heading && <h1 className="front-page-hero__heading">{heading}</h1>}
          </div>
          <div className="front-page-hero__bottom-panel">
            {reportDownloadLink && (
              <LinkButton
                className="front-page-hero__button"
                iconName="download"
                download
                {...reportDownloadLink}
              />
            )}
            <GoToPageContent
              ariaLabel={lang.goToPageContentAriaLabel}
              className="front-page-hero__go-to-page-content-button"
            />
          </div>
        </div>
      </div>
      {image && imageHeight && imageWidth ? (
        <Image
          {...image}
          fluid={true}
          width={imageWidth}
          height={imageHeight}
          className="front-page-hero__image image_size_front-page-hero"
        />
      ) : null}
    </div>
  );
};

FrontPageHero.propTypes = {
  heading: PropTypes.string,
  smallHeading: PropTypes.string,
  image: PropTypes.exact(Image.propTypes),
  reportDownloadLink: PropTypes.exact(Link.propTypes),
  lang: PropTypes.shape({
    goToPageContentAriaLabel: PropTypes.string.isRequired,
  }).isRequired,
};

export default FrontPageHero;
